<!-- COMPLETED CARD -->
<div class="fgbcl-completed-scorecard cursor-pointer" *ngIf="scorecard.Completed">
  <div class="fgbcl-scorecard-completed-top d-flex flex-column align-items-center w-100">
    <div class="badge-sparkle-wrapper flex-shrink-0">
      <img [src]="scorecard.Image | contentImage: '6'" alt="" class="badge-img" />
      <span class="badge-sparkle badge-sparkle-1"></span>
      <span class="badge-sparkle badge-sparkle-2"></span>
      <span class="badge-sparkle badge-sparkle-3"></span>
      <span class="badge-sparkle badge-sparkle-4"></span>
    </div>
    <p class="fgbcl-scorecard-completed-title text-center w-100">{{ scorecard.Name }}</p>
    <p class="fgbcl-scorecard-completed-desc mb-0 text-center w-100">
      {{ scorecard.ShortDescription }}
    </p>
  </div>
  <div
    class="fgbcl-scorecard-prize-pill d-flex align-items-center justify-content-center gap-2 w-100"
    *ngIf="scorecard.PrizeDescription"
  >
    <span class="material-symbols-outlined fgbcl-scorecard-pill-icon">featured_seasonal_and_gifts</span>
    <span class="fgbcl-scorecard-pill-text">{{ scorecard.PrizeDescription }}</span>
  </div>
</div>

<!-- ACTIVE CARD (non-completed) -->
<ng-container *ngIf="!scorecard.Completed">
  <div class="fgbcl-scorecard-challenge-card d-flex flex-column cursor-pointer">
    <!-- Header -->
    <div class="fgbcl-scorecard-card-header d-flex flex-column gap-3" [class.header-locked]="isHeaderLocked(scorecard)">
      <div class="d-flex align-items-center gap-2">
        <div class="fgbcl-scorecard-card-icon flex-shrink-0">
          <img [src]="scorecard.Image | contentImage: '6'" alt="" class="card-icon-img" />
        </div>
        <div class="fgbcl-scorecard-card-info">
          <p class="fgbcl-scorecard-card-title mb-1" [class.card-title-dark]="isHeaderLocked(scorecard)">{{ scorecard.Name }}</p>
          <p class="fgbcl-scorecard-card-desc mb-0" [class.card-desc-dark]="isHeaderLocked(scorecard)">
            {{ scorecard.ShortDescription }}
          </p>
        </div>
      </div>
      <div
        class="fgbcl-scorecard-prize-pill d-flex align-items-center justify-content-center gap-2"
        [class.pill-locked]="isHeaderLocked(scorecard)"
        *ngIf="scorecard.PrizeDescription"
      >
        <span class="material-symbols-outlined fgbcl-scorecard-pill-icon" [class.pill-icon-locked]="isHeaderLocked(scorecard)"
          >featured_seasonal_and_gifts</span
        >
        <span class="fgbcl-scorecard-pill-text" [class.pill-text-locked]="isHeaderLocked(scorecard)">{{
          scorecard.PrizeDescription
        }}</span>
      </div>
    </div>

    <!-- Footer: standalone locked -->
    <div class="fgbcl-scorecard-card-footer locked-footer-wrap" *ngIf="scorecard.Locked && !linkedChild && !hideLocked">
      <div class="d-flex align-items-center justify-content-center gap-1">
        <span class="fgbcl-scorecard-lock-label">{{ 'fgbcl.challenges.locked' | translate }}</span>
        <span class="material-icons lock-icon">lock</span>
      </div>
    </div>

    <!-- Footer: progress (punchcard / progressBar / singleAction) -->
    <div class="fgbcl-scorecard-card-footer" *ngIf="!scorecard.Locked && isProgressType(scorecard)">
      <div class="fgbcl-scorecard-footer-row d-flex align-items-center justify-content-between mb-2">
        <span class="fgbcl-scorecard-footer-label"
          >{{ scorecard.ActionsCompleted }} {{ 'fgbcl.challenges.actions.completed' | translate }}</span
        >
        <span class="fgbcl-scorecard-footer-value">{{ getProgressPercentage(scorecard) }}%</span>
      </div>
      <div class="fgbcl-scorecard-progress-track d-flex overflow-hidden">
        <div class="fgbcl-scorecard-progress-fill" [style.width.%]="getProgressPercentage(scorecard)"></div>
        <div class="fgbcl-scorecard-progress-empty flex-grow-1"></div>
      </div>
      <ng-container *ngTemplateOutlet="lockedChildTpl"></ng-container>
      <ng-container *ngTemplateOutlet="sponsorTpl"></ng-container>
    </div>

    <!-- Footer: solo action -->
    <div class="fgbcl-scorecard-card-footer" *ngIf="!scorecard.Locked && isSoloAction(scorecard)">
      <div class="fgbcl-scorecard-footer-row d-flex align-items-center gap-3">
        <span class="fgbcl-scorecard-solo-action-label flex-grow-1">{{ getSoloActionName(scorecard) }}</span>
      </div>
      <ng-container *ngTemplateOutlet="lockedChildTpl"></ng-container>
      <ng-container *ngTemplateOutlet="sponsorTpl"></ng-container>
    </div>

    <!-- Footer: milestone -->
    <div class="fgbcl-scorecard-card-footer" *ngIf="!scorecard.Locked && isMilestoneType(scorecard)">
      <div class="fgbcl-scorecard-footer-row d-flex align-items-center justify-content-between mb-2">
        <span class="fgbcl-scorecard-footer-label">{{ scorecard | scorecardV2MilestoneValue | async }}</span>
        <span class="fgbcl-scorecard-footer-value"
          >{{ scorecard.Milestone?.CustomerValue }}/{{ getMaxMilestone(scorecard) }}</span
        >
      </div>
      <div class="fgbcl-scorecard-milestone-bar d-flex align-items-center gap-1">
        <ng-container *ngFor="let m of getMilestonesSorted(scorecard); let i = index">
          <div class="ms-segment flex-grow-1 overflow-hidden">
            <div class="ms-segment-fill" [style.width.%]="getMilestoneSegmentFill(scorecard, i)"></div>
          </div>
          <div class="ms-dot flex-shrink-0" [class.ms-dot-filled]="isMilestoneReached(scorecard, m.Value)"></div>
        </ng-container>
      </div>
      <ng-container *ngTemplateOutlet="lockedChildTpl"></ng-container>
      <ng-container *ngTemplateOutlet="sponsorTpl"></ng-container>
    </div>

    <!-- Footer: counter -->
    <div class="fgbcl-scorecard-card-footer" *ngIf="!scorecard.Locked && isCounterType(scorecard)">
      <div class="fgbcl-scorecard-footer-row d-flex align-items-center justify-content-between">
        <span class="fgbcl-scorecard-footer-label">{{ 'fgbcl.challenges.total.completed' | translate }}</span>
        <span class="fgbcl-scorecard-footer-value">{{ scorecard.ActionsCompleted }}</span>
      </div>
      <ng-container *ngTemplateOutlet="lockedChildTpl"></ng-container>
      <ng-container *ngTemplateOutlet="sponsorTpl"></ng-container>
    </div>
  </div>
</ng-container>

<!-- Inline locked child preview -->
<ng-template #lockedChildTpl>
  <ng-container *ngIf="linkedChild && !hideLocked">
    <div class="fgbcl-scorecard-footer-divider"></div>
    <p class="fgbcl-scorecard-complete-unlock-label mb-2">{{ 'fgbcl.challenges.complete.unlock' | translate }}</p>
    <div class="fgbcl-scorecard-locked-child-card d-flex align-items-center gap-2" (click)="onChildClick($event)">
      <div class="fgbcl-scorecard-child-card-icon flex-shrink-0">
        <img [src]="linkedChild.Image | contentImage: '6'" alt="" class="child-card-icon-img" />
      </div>
      <div class="fgbcl-scorecard-child-card-info flex-grow-1 d-flex align-items-center gap-1">
        <p class="fgbcl-scorecard-child-card-title mb-0">{{ linkedChild.Name }}</p>
        <span class="material-icons fgbcl-scorecard-child-lock-icon flex-shrink-0">lock</span>
      </div>
      <span class="material-icons child-chevron flex-shrink-0">keyboard_arrow_right</span>
    </div>
  </ng-container>
</ng-template>

<!-- Sponsor row, shown at the bottom of the footer when the scorecard has a sponsor logo -->
<ng-template #sponsorTpl>
  <div class="fgbcl-scorecard-sponsor-footer d-flex flex-column" *ngIf="scorecard.Sponsor?.SponsorImage">
    <div class="fgbcl-scorecard-sponsor-divider"></div>
    <!-- The row links out to the sponsor when a link is set; the card click is stopped so the panel does not open -->
    <a
      *ngIf="scorecard.Sponsor?.SponsorLink; else sponsorPlainRow"
      class="fgbcl-scorecard-sponsor-row fgbcl-scorecard-sponsor-link d-flex align-items-center justify-content-end"
      [href]="scorecard.Sponsor?.SponsorLink"
      target="_blank"
      rel="noopener noreferrer"
      (click)="$event.stopPropagation()"
    >
      <ng-container *ngTemplateOutlet="sponsorContentTpl"></ng-container>
    </a>
    <ng-template #sponsorPlainRow>
      <div class="fgbcl-scorecard-sponsor-row d-flex align-items-center justify-content-end">
        <ng-container *ngTemplateOutlet="sponsorContentTpl"></ng-container>
      </div>
    </ng-template>
  </div>
</ng-template>

<ng-template #sponsorContentTpl>
  <span class="fgbcl-scorecard-sponsor-label" *ngIf="scorecard.Sponsor?.SponsorText">{{ scorecard.Sponsor?.SponsorText }}</span>
  <img
    class="fgbcl-scorecard-sponsor-img flex-shrink-0"
    [src]="scorecard.Sponsor?.SponsorImage | contentImage: '1'"
    [alt]="scorecard.Sponsor?.SponsorText || ''"
  />
</ng-template>
